import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0884e91b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "head"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head-title"
}, "525心理加油站 · 后台管理系统", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_router_link, {
    to: "/home/member-info"
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock("div", {
      class: "head-user",
      key: Date.now()
    }, "当前用户：" + _toDisplayString($data.userName), 1))]),
    _: 1
  })]);
}